export default __webpack_public_path__ + "static/media/landing_KOR_04.45b8f333.png";